var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "机构考核证书到期提醒",
        okText: "确认",
        cancelText: "取消",
        width: "800px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "机构代码", prop: "code" } },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "code", $$v)
                          },
                          expression: "formState.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "检测机构名称", prop: "name" } },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "name", $$v)
                          },
                          expression: "formState.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "所属区域", prop: "xzqhName" } },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.regionName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "regionName", $$v)
                          },
                          expression: "formState.regionName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "机构联系方式", prop: "orgTel" } },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.orgTel,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "orgTel", $$v)
                          },
                          expression: "formState.orgTel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "法定代表人",
                        prop: "bossName",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.bossName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "bossName", $$v)
                          },
                          expression: "formState.bossName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "机构所在地址",
                        prop: "address",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "address", $$v)
                          },
                          expression: "formState.address",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "联系人", prop: "connectName" } },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.connectName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "connectName", $$v)
                          },
                          expression: "formState.connectName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "联系人电话", prop: "connectTel" } },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.connectTel,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "connectTel", $$v)
                          },
                          expression: "formState.connectTel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "许可决定日期",
                        prop: "accessJudgeDate",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.accessJudgeDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "accessJudgeDate", $$v)
                          },
                          expression: "formState.accessJudgeDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "有效期自", prop: "accessStartDate" } },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.accessStartDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "accessStartDate", $$v)
                          },
                          expression: "formState.accessStartDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "有效期至", prop: "accessEndDate" } },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value: _vm.formState.accessEndDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "accessEndDate", $$v)
                          },
                          expression: "formState.accessEndDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "距到期时间",
                        prop: "dateDepart",
                      },
                    },
                    [
                      _c("a-ext-bold-a", {
                        model: {
                          value:
                            _vm.formState.datePart.replace("-", "已超期") +
                            "天",
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.formState.datePart,
                              "replace('-','已超期')+'天'",
                              $$v
                            )
                          },
                          expression:
                            "formState.datePart.replace('-','已超期')+'天'",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.onAlertSetModalOpen(_vm.formState)
                        },
                      },
                    },
                    [_vm._v("发布短信通知")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.alertSetModalVisable
        ? _c("alert-set-modal", {
            attrs: {
              visible: _vm.alertSetModalVisable,
              param: _vm.alertSetModalParam,
            },
            on: {
              "update:visible": function ($event) {
                _vm.alertSetModalVisable = $event
              },
              addModalClose: _vm.onAlertSetModalClose,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }